import { useCallback, useState } from "react";
import { useLazyQuery } from "@apollo/client";

import { GET_PREQUALIFICATION_CHECKOUT_URL } from "./prequalification-checkout.query";
import type {
  IPrequalificationCheckoutUrlResponse,
  IPrequalificationCheckoutUrlVars,
} from "./prequalification-checkout.interface";

export const CHECKOUT_URL_UNAVAILABLE = "PREQUALIFICATION_CHECKOUT_UNAVAILABLE";

export const usePrequalificationCheckoutUrl = () => {
  const [scratchpayUrl, setScratchpayUrl] = useState<string | undefined>();
  const [error, setError] = useState<Error | undefined>();

  const [executeQuery, { loading }] = useLazyQuery<
    IPrequalificationCheckoutUrlResponse,
    IPrequalificationCheckoutUrlVars
  >(GET_PREQUALIFICATION_CHECKOUT_URL, {
    fetchPolicy: "no-cache",
    context: { suppressGlobalErrorToast: true },
  });

  const fetchCheckoutUrl = useCallback(
    async (prequalificationId: string) => {
      setError(undefined);
      setScratchpayUrl(undefined);

      try {
        const { data, error: queryError } = await executeQuery({
          variables: { prequalificationId },
        });

        if (queryError) {
          setError(queryError);
          return;
        }

        const url = data?.prequalificationCheckoutUrl;
        if (!url) {
          setError(new Error(CHECKOUT_URL_UNAVAILABLE));
          return;
        }

        setScratchpayUrl(url);
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error(CHECKOUT_URL_UNAVAILABLE),
        );
      }
    },
    [executeQuery],
  );

  return { fetchCheckoutUrl, scratchpayUrl, loading, error };
};
